import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PublicProfile.module.css';
import PeopleModal from './PeopleModal';
import {
  getPublicProfile,
  followUser,
  unfollowUser,
  getRecordedLiveShow,
  getClipsByProfileId,
  resetFollowList,
} from '../../redux/actions/publicProfile';
import { Link, useParams } from 'react-router-dom';
import { blockUser, unBlockUser } from '../../redux/actions/auth';
import Loading from '../Loading/Loading';
import { getInitial } from '../../utils';

import userIcon from '../../assets/ic-user.svg';
// import share from '../../assets/share.svg'
import plusIcn from '../../assets/ic-plus.svg';
import emptyIcon from '../../assets/empty-icon.svg';
import btnEditProfile from '../../assets/btn-edit-profile.svg';
import btnShareProfile from '../../assets/share.svg';
import blurrPoster from '../../assets/public-profile-bg.svg';

import diamondIcn from '../../assets/diamonds.svg';
import { clipsID, errorCode } from '../../constants';
import { PlaylistPageView } from '..';
import SendGiftModal from './SendGiftModal';
import analytic, {
  analyticEvents,
  analyticTypes,
} from '../../service/analytic';
import { authPopup, isBlockBlockedProfile } from '../../redux/actions/auth';
import { ClipsCollectionItem } from '..';
import Observer from 'react-intersection-observer';
import ReportModal from '../ReportModal';
import ShareModal from '../ShareModal/ShareModal';
import CSSTransition from 'react-transition-group/CSSTransition';
import GeneralNotifModal from '../GeneralModal/generalNotifModal';
import blockIcn from '../../assets/block-circle.svg';
import unblockIcn from '../../assets/unblock-icn.svg';
import reportIcn from '../../assets/report-icon.svg';
import radioChecked from '../../assets/radio-checked.svg';
import moreIcn from '../../assets/more.svg';
import useSettings from '../../hooks/useSettings';

const MAIN_TABS = ['Previous Live Show', 'Clips'];

const PublicProfile = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showSendGiftModal, setShowSendGiftModal] = useState(false);
  const [tab, setTab] = useState(0);
  const auth = useSelector((state) => state.auth);
  const publicProfile = useSelector((state) => state.publicProfile);
  const {
    profileInfo,
    loadingProfile,
    err,
    dataVod,
    metaVod,
    loadingVod,
    loadingFollow,
    loadingClips,
    dataClips,
    metaClips,
  } = publicProfile;
  const userToken = auth && auth.token;
  const userId = auth.user && auth.user.profile && auth.user.profile.id;
  const profileId = params.profileID;
  const [pageVod, setPageVod] = useState(1);
  const [pageClips, setClipsPage] = useState(1);
  const perPageVod = 10;
  const [mainTab, setTabForliveShowClips] = useState(0);

  const [moreDialog, setMoreDialog] = useState(false);
  const [showReportModal, setReportModal] = useState(false);
  const [showBlockModal, setBlockModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [blockStringTitle, setBlockTitle] = useState('');
  const [blockStringDescription, setBlockDescription] = useState('');
  const [isBlocked, setBlocked] = useState(false);
  const [blockType, setBlockType] = useState('block');

  const completed =
    !loadingClips && metaClips && metaClips.totalPages <= pageClips;

  const blockButton = blockType === 'unblock' ? 'Unblock' : 'Block';
  const blockIcon = blockType === 'unblock' ? unblockIcn : blockIcn;

  const settings = useSettings();

  const replaceBlockeeName = (str, name) => {
    if (str) {
      str = str.replace('[blockee_name]', name);
      if (str.includes('\\n\\n')) {
        return (
          <span>
            {str.split('\\n\\n')[0]} <br />
            <br />
            {str.split('\\n\\n')[1]}
          </span>
        );
      }

      return str;
    }
  };

  useEffect(() => {
    const checkIsBlocked = async (data) => {
      try {
        const res = await dispatch(
          isBlockBlockedProfile(data.profile.accountId, data.profile.id)
        );

        if (res?.data?.status === 'BLOCKING') {
          setBlockType('unblock');
        }

        if (res?.data?.status === 'BLOCKED') {
          setBlockType('access');
        }
        if (!res) {
          setBlockType('block');
        }
      } catch (error) {
        setBlockType('block');
      }
    };

    profileInfo && checkIsBlocked(profileInfo);
  }, [profileInfo, dispatch, setBlockType]);
  useEffect(() => {
    setBlocked(profileInfo?.block ? true : false);
    if (blockType) {
      if (blockType === 'access') {
        setBlockTitle(`Access Denied`);
        setBlockDescription(`You have been blocked by the user`);
        return;
      }

      if (blockType === 'unblock') {
        setBlockTitle(`You blocked ${profileInfo?.profile?.name}`);
        const contentmessage = replaceBlockeeName(
          settings.blockerAccessContentMessage,
          profileInfo?.profile?.name
        );
        setBlockDescription(contentmessage);
        // setBlockDescription(
        //   `${profileInfo?.name} will now be able to see your liveshow, clips, follow and send chat/message on your content.`
        // );
      }
    } else {
      setBlockTitle(`Block ${profileInfo?.profile?.name}?`);
      setBlockDescription(
        `Block means you or he/she will no longer be able to send message, follow and watch your content`
      );
    }
  }, [profileInfo, settings.blockerAccessContentMessage, blockType]);

  useEffect(() => {
    if (profileInfo) {
      analytic(
        analyticTypes.event,
        analyticEvents.PUBLIC_PROFILE.VIEW_USER_PROFILE,
        {
          params: { publicProfile: profileInfo },
          user: auth.user,
        }
      );
    }
  }, [profileInfo, auth.user]);

  useEffect(() => {
    dispatch(getPublicProfile(profileId));
  }, [dispatch, profileId]);

  useEffect(() => {
    return () => {
      dispatch(resetFollowList());
    };
  }, [dispatch]);

  useEffect(() => {
    if (mainTab === 0) {
      dispatch(getRecordedLiveShow(profileId, pageVod, perPageVod));
    }

    if (mainTab === 1) {
      dispatch(getClipsByProfileId(profileId, pageClips, perPageVod, clipsID));
    }
  }, [dispatch, profileId, pageVod, pageClips, mainTab]);

  useEffect(() => {
    setPageVod(1);
    setClipsPage(1);
  }, [profileId]);

  const fetchNextDataVod = () => {
    if (mainTab === 0) {
      setPageVod(pageVod + 1);
    }
    if (mainTab === 1 && !loadingClips) {
      setClipsPage(pageClips + 1);
    }
  };

  const handleShowModal = (tabNumber) => {
    if (!userToken) {
      localStorage.setItem('gfRedirectPath', window.location.pathname);
      return dispatch(authPopup.show());
    }

    setTab(tabNumber);
    setShowModal(true);
  };

  const handleFollowUser = useCallback(async () => {
    if (!userToken) {
      localStorage.setItem('gfRedirectPath', window.location.pathname);
      return dispatch(authPopup.show());
    }

    if (isBlocked) {
      const title =
        blockType === 'access'
          ? `Access Denied`
          : `You blocked ${profileInfo?.profile?.name}`;
      setBlockTitle(title);

      let followStringDescription =
        blockType === 'access' ? (
          <span>
            {' '}
            {replaceBlockeeName(
              settings.blockeeFollowProfileMessage,
              profileInfo?.profile?.name
            )}
          </span>
        ) : (
          <span>
            {/* You are not able to follow this profile. To follow this profile, you
            need to unblock the user. <br /> <br /> Are you sure want to unblock{' '}
            {profile.name}? */}
            {replaceBlockeeName(
              settings.blockerFollowProfileMessage,
              profileInfo?.profile?.name
            )}
          </span>
        );
      setBlockDescription(followStringDescription);
      setBlockModal(true);
      return;
    }

    const relationId = profileInfo?.profile?.profileRelationId;

    profileInfo?.relation?.isFollowing
      ? await dispatch(unfollowUser(relationId, profileId))
      : await dispatch(followUser(profileId));

    dispatch(getPublicProfile(profileId));
  }, [
    settings.blockerFollowProfileMessage,
    dispatch,
    isBlocked,
    profileInfo,
    profileId,
    userToken,
    settings.blockeeFollowProfileMessage,
    blockType,
  ]);

  const onBlockUnblockDone = useCallback(() => {
    setMoreDialog(false);
    dispatch(getPublicProfile(profileId));
  }, [profileId, dispatch]);
  const generateDataItems = (data) => {
    const maxItemsPerRow = 4;
    const results = [];

    data
      .filter((item) => {
        return item.type !== '-';
      })
      .forEach((item) => {
        return results.push(
          <ClipsCollectionItem
            key={item.id}
            data={item}
            playlistType='playlist'
            onBlockUnblockDone={onBlockUnblockDone}
          />
        );
      });

    for (let i = 1; i <= maxItemsPerRow - (data.length % maxItemsPerRow); i++) {
      results.push(<ClipsCollectionItem empty={true} key={`empty_${i}`} />);
    }

    return results;
  };

  const handleOpenGiftModal = () => {
    if (!userToken) {
      localStorage.setItem('gfRedirectPath', window.location.pathname);
      return dispatch(authPopup.show());
    }

    setShowSendGiftModal(true);
  };

  const renderMoreDialog = () => {
    return (
      <CSSTransition in={moreDialog} classNames='fade' unmountOnExit>
        <div className={styles['popup-menu']}>
          <div
            className={styles.popupMenuWrapper}
            onClick={() => {
              if (!userToken) {
                localStorage.setItem(
                  'gfRedirectPath',
                  window.location.pathname
                );
                return dispatch(authPopup.show());
              }

              let title = `Block ${profileInfo?.profile?.name}?`;
              let desc = `Block means you or he/she will no longer be able to send message, follow and watch your content`;
              let type = 'block';
              if (blockType === 'unblock') {
                title = replaceBlockeeName(
                  settings.blockerUnblockDialogTitle,
                  profileInfo?.profile?.name
                );
                desc = replaceBlockeeName(
                  settings.blockerUnblockDialogMessage,
                  profileInfo?.profile?.name
                );
                type = 'unblock';
              }

              setBlockType(type);
              setBlockTitle(title);
              setBlockDescription(desc);
              setBlockModal(!showBlockModal);
              setMoreDialog(!moreDialog);
            }}
          >
            <img
              src={blockIcon}
              alt='block'
              style={{ width: '20px', height: '24px', marginRight: '12px' }}
            />
            <span>{blockButton}</span>
          </div>
          <div
            className={styles.popupMenuWrapper}
            onClick={() => {
              if (!userToken) {
                localStorage.setItem(
                  'gfRedirectPath',
                  window.location.pathname
                );
                return dispatch(authPopup.show());
              }
              setReportModal(!showReportModal);
              setMoreDialog(!moreDialog);
            }}
          >
            <img
              src={reportIcn}
              alt='report'
              style={{ width: '20px', height: '20px', marginRight: '12px' }}
            />
            <span>Report</span>
          </div>
        </div>
      </CSSTransition>
    );
  };

  const closeAllModals = () => {
    setReportModal(false);
    setMoreDialog(false);
    setBlockModal(false);
    setMoreDialog(false);
    setShowSuccessModal(false);
  };

  const blockProfile = async () => {
    if (profileInfo?.profile?.accountId) {
      const res = await dispatch(blockUser(profileInfo?.profile?.accountId));
      if (res) {
        setBlocked(true);
        setBlockModal(false);
        setShowSuccessModal(true);
        dispatch(getPublicProfile(profileId));
      }
    }
  };

  const unBlockUserProfile = async () => {
    if (profileInfo?.profile?.accountId) {
      const res = await dispatch(unBlockUser(profileInfo?.profile?.accountId));
      if (res) {
        setBlocked(true);
        closeAllModals();
        dispatch(getPublicProfile(profileId));
      }
    }
  };

  const renderBlockModal = () => {
    return (
      <GeneralNotifModal open={showBlockModal || showSuccessModal}>
        {showBlockModal && (
          <div className={styles.reportContainer}>
            <div
              className={styles.blockTitle}
              style={{
                color: `${blockType === 'access' ? '#F20303' : '#F49832'}`,
              }}
            >
              {blockStringTitle}
            </div>
            <div className={styles.blockSubTitle}>{blockStringDescription}</div>
            {blockType === 'access' && (
              <div
                className={styles.reportButton}
                style={{
                  backgroundColor: '#F49832',
                }}
                onClick={() => {
                  closeAllModals();
                }}
              >
                Close
              </div>
            )}
            {blockType !== 'access' && (
              <>
                <div
                  className={styles.reportButton}
                  onClick={() => {
                    blockType === 'unblock'
                      ? unBlockUserProfile()
                      : blockProfile();
                    // setBlocked(true)
                  }}
                >
                  {blockButton}
                </div>
                <div
                  className={styles.cancelButton}
                  onClick={() => {
                    closeAllModals();
                  }}
                >
                  Cancel
                </div>
              </>
            )}
          </div>
        )}
        {showSuccessModal && (
          <div className={styles.reportContainer}>
            <img src={radioChecked} alt='radio' height='40' width='40' />
            <div className={styles.reportThanksTitle}>
              {profileInfo?.profile?.name} has been blocked
            </div>
            <div className={styles.reportThanksSubTitle} sty>
              You can unblock them anytime from your profile.
            </div>
            <div
              className={styles.closeButton}
              onClick={() => {
                closeAllModals();
              }}
            >
              Close
            </div>
          </div>
        )}
      </GeneralNotifModal>
    );
  };

  if (err && err.code === errorCode.INVALID_PARAMETERS) {
    return (
      <div
        style={{
          height: 300,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <p>User Not Found</p>
      </div>
    );
  }

  if (loadingProfile || !profileInfo) {
    return <Loading height='100vh' />;
  }

  return (
    <>
      <div>
        <div className={styles.profileWrapper}>
          <div className={styles.profileSection}>
            <div
              className={`${styles.poster} ${
                profileInfo?.profile?.avatar ? '' : ''
              }`}
              style={{
                backgroundImage: `${
                  profileInfo?.profile?.avatar ? `url(${blurrPoster})` : ''
                }`,
              }}
            ></div>
            <div className={styles.contentContainer}>
              <div className={styles.profileDetail}>
                <div className={styles.profileInfo}>
                  <div className={styles.avatarSection}>
                    {!!profileInfo?.profile?.avatar ? (
                      <img
                        src={
                          !!profileInfo?.profile?.avatar
                            ? profileInfo?.profile?.avatar
                            : userIcon
                        }
                        alt='avatar'
                        className={styles.avatar}
                      />
                    ) : (
                      <div className={styles.avatar} data-initial-name>
                        {getInitial(profileInfo?.profile?.name)}
                      </div>
                    )}
                  </div>
                  <div className={styles.profileDescription}>
                    <div className={styles.titleSection}>
                      <span
                        title={profileInfo?.profile.name}
                        className={styles.profileName}
                      >
                        {profileInfo?.profile.name}
                      </span>
                      {/* <img src={bronzBadgeIcn} alt="badge" style={{ margin: '0px 1rem' }} /> */}
                      {profileId === userId && (
                        <Link to={'/profile'}>
                          <img
                            style={{ margin: '0px 1rem' }}
                            src={btnEditProfile}
                            alt='edit profile'
                          />
                        </Link>
                      )}
                    </div>
                    <span title={profileInfo?.profile.bio}>
                      {profileInfo?.profile.bio}
                    </span>
                    <div className={styles.followerSection}>
                      <div onClick={() => handleShowModal(0)}>
                        <span>{profileInfo?.relation.totalFollowers}</span>
                        <span>Followers</span>
                      </div>
                      <div className={styles.verticalLine} />
                      <div onClick={() => handleShowModal(1)}>
                        <span>{profileInfo?.relation.totalFollowings}</span>
                        <span>Following</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.extraActions}>
                  <div
                    className={`${styles.extraActionButton} `}
                    onClick={() => setShowShareModal(!showShareModal)}
                  >
                    <img
                      src={btnShareProfile}
                      alt='share'
                      width='17'
                      height='19'
                    />
                    <span>Share Profile</span>
                  </div>
                  {profileId !== userId && (
                    <>
                      <div
                        className={`${styles.extraActionButton} ${styles.sendDiamondButton}`}
                        onClick={handleOpenGiftModal}
                      >
                        <img
                          src={diamondIcn}
                          alt='share'
                          width='17'
                          height='19'
                        />
                        <span>Send Diamond</span>
                      </div>
                      <div
                        className={`${styles.extraActionButton} ${styles.follow}`}
                        onClick={!loadingFollow && handleFollowUser}
                      >
                        {profileInfo?.relation.isFollowing ? (
                          <span>Unfollow</span>
                        ) : (
                          <>
                            <img src={plusIcn} alt='plus-white' />
                            <span>Follow</span>
                          </>
                        )}
                      </div>
                    </>
                  )}

                  {profileId !== userId && (
                    <div className={styles.morebutton}>
                      <img
                        src={moreIcn}
                        alt='more'
                        onClick={() => {
                          setMoreDialog(!moreDialog);
                        }}
                      />
                      {renderMoreDialog()}
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.vodContainer}>
                <div className={styles.mainTabContainer}>
                  {MAIN_TABS.map((tab, i) => {
                    return (
                      <h3
                        style={{
                          color: mainTab === i ? '#F49832' : '',
                          cursor: 'pointer',
                        }}
                        onClick={() => setTabForliveShowClips(i)}
                      >
                        {MAIN_TABS[i]}
                      </h3>
                    );
                  })}
                </div>

                {mainTab === 0 ? (
                  <div>
                    {loadingVod ? (
                      <Loading />
                    ) : dataVod && !!dataVod.length ? (
                      <>
                        <PlaylistPageView
                          onBlockUnblockDone={onBlockUnblockDone}
                          fetchNextData={fetchNextDataVod}
                          data={dataVod}
                          completed={
                            !loadingVod &&
                            metaVod &&
                            pageVod >= metaVod.totalPages
                          }
                        />
                      </>
                    ) : (
                      <div className={styles.emptyContent}>
                        <img src={emptyIcon} alt='no-video' />
                        {profileId === userId ? (
                          <p>You don’t have any previous liveshow video.</p>
                        ) : (
                          <p>This streamer currently has no video content.</p>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    {loadingClips && pageClips === 1 ? (
                      <Loading height='100px' />
                    ) : (
                      <>
                        <div className={styles.listContainer}>
                          {dataClips &&
                            profileInfo?.profile &&
                            generateDataItems([
                              ...dataClips.map((clip) => ({
                                ...clip,
                                profile: profileInfo?.profile,
                              })),
                            ])}
                        </div>
                        {!loadingClips && !dataClips?.length && !err && (
                          <div className={styles.emptyContent}>
                            <img src={emptyIcon} alt='no-video' />
                            {profileId === userId ? (
                              <p>You don’t have any clips video.</p>
                            ) : (
                              <p>
                                This streamer currently has no video content.
                              </p>
                            )}
                          </div>
                        )}
                        {err && (
                          <p className={styles.centerMessage} data-error>
                            Error: Cannot get clips data
                          </p>
                        )}
                        {!err && !completed && (
                          <div className={styles['loader-wrapper']}>
                            <Observer
                              onChange={(inView) => {
                                inView &&
                                  dataClips?.length &&
                                  fetchNextDataVod();
                              }}
                            >
                              <Loading height='100px' />
                            </Observer>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <PeopleModal
          show={showModal}
          tab={tab}
          setTab={setTab}
          onClose={() => setShowModal(false)}
        />
      )}

      {showShareModal && (
        <ShareModal
          onCloseModal={() => setShowShareModal(!showShareModal)}
          type={'profile'}
          id={profileId}
          showShareModal={showShareModal}
        />
      )}
      {userToken && (
        <SendGiftModal
          show={showSendGiftModal}
          giftType='publicProfile'
          onShow={() => setShowSendGiftModal(true)}
          onClose={() => setShowSendGiftModal(false)}
        />
      )}
      {profileInfo && showReportModal && (
        <ReportModal
          profile={profileInfo?.profile}
          idEntity={profileInfo?.profile?.id}
          valueEntity={profileInfo?.profile?.name}
          isTriggeredReport={showReportModal}
          onReportClose={(type) => {
            setReportModal(false);
          }}
        />
      )}
      {renderBlockModal()}
    </>
  );
};

export default PublicProfile;
